import React from 'react';

// const Featured = () => {
//   return (
//     <div className="main-content">
//       <h2>Featured: </h2>
//       <p>Introducing <strong></strong>, a teacher who loves teaching courses about <strong></strong>!</p>
//     </div>
//   );
// }

// 65) The parameter data is passed to the "Featured" component through the match object's param property (match.params). So let's add match as an argument to the Featured component. (Don't forget to add the react expression brackets.) ...

// const Featured = ({match}) => {
//   return (
//     <div className="main-content">
//       <h2>Featured: </h2>
//       <p>Introducing <strong></strong>, a teacher who loves teaching courses about <strong></strong>!</p>
//     </div>
//   );
// }

// 66) Now we can save the parameters locally inside the components using local variables ...

// const Featured = ({match}) =>{
//   let name = match.params.name;
//   let topic = match.params.topic;
//   return (
//     <div className="main-content">
//       <h2>Featured: </h2>
//       <p>Introducing <strong></strong>, a teacher who loves teaching courses about <strong></strong>!</p>
//     </div>
//   );
// }

// 67) And now to render the parameter as content in the component we include the name and topic variables in the returned JSX. See below then go to ((Home.js))

// const Featured = ({match}) =>{
//   let name = match.params.name;
//   let topic = match.params.topic;
//   return (
//     <div className="main-content">
//       <h2>{ name }</h2>
//       <p>Introducing <strong>{ name }</strong>, a teacher who loves teaching courses about <strong>{ topic }</strong>!</p>
//     </div>
//   );
// }

// 71) Now combine the two name parameters using a template literal and add the returned value to the local name variable. view below then ((go to Home.js))

// const Featured = ({match}) =>{
//   let name = `${match.params.fname} ${match.params.lname}`;
//   let topic = match.params.topic;
//   return (
//     <div className="main-content">
//       <h2>{ name }</h2>
//       <p>Introducing <strong>{ name }</strong>, a teacher who loves teaching courses about <strong>{ topic }</strong>!</p>
//     </div>
//   );
// }

// 81) Now we add a 2nd name variable called name2 and create another <h2> element in the JSX for the name2 parameter.

const Featured = ({match}) =>{
  let name;
  if(match.params.fname && match.params.lname)
    name = `${match.params.fname} ${match.params.lname}`;
  else
    name = match.params.name;
  let topic = match.params.topic;
  return (
    <div className="main-content">
      <h2>{ name }</h2>
      <p>Introducing <strong>{ name }</strong>, a teacher who loves teaching courses about <strong>{ topic }</strong>!</p>
    </div>
  );
}

export default Featured;



// WEBPACK FOOTER //
// ./src/components/Featured.js